/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Feature access denied audit event
 * @export
 * @interface FeatureAccessDeniedEventDto
 */
export interface FeatureAccessDeniedEventDto {
    /**
     * Audit log entry ID
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    id?: string;
    /**
     * Tenant that was denied access
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    tenantId?: string;
    /**
     * Display name of the tenant where the denial occurred
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    tenantName?: string;
    /**
     * Display name of the customer (tenant's customer)
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    resourceType?: string;
    /**
     * Feature ID that was denied, e.g. nist_csf_program
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    resourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    userId?: string;
    /**
     * Username (e.g. email) of the user who attempted access
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    username?: string;
    /**
     * When the denial occurred (ISO-8601)
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof FeatureAccessDeniedEventDto
     */
    businessContext?: string;
}

/**
 * Check if a given object implements the FeatureAccessDeniedEventDto interface.
 */
export function instanceOfFeatureAccessDeniedEventDto(value: object): value is FeatureAccessDeniedEventDto {
    return true;
}

export function FeatureAccessDeniedEventDtoFromJSON(json: any): FeatureAccessDeniedEventDto {
    return FeatureAccessDeniedEventDtoFromJSONTyped(json, false);
}

export function FeatureAccessDeniedEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureAccessDeniedEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'action': json['action'] == null ? undefined : json['action'],
        'resourceType': json['resourceType'] == null ? undefined : json['resourceType'],
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'username': json['username'] == null ? undefined : json['username'],
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
        'businessContext': json['businessContext'] == null ? undefined : json['businessContext'],
    };
}

export function FeatureAccessDeniedEventDtoToJSON(json: any): FeatureAccessDeniedEventDto {
    return FeatureAccessDeniedEventDtoToJSONTyped(json, false);
}

export function FeatureAccessDeniedEventDtoToJSONTyped(value?: FeatureAccessDeniedEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'customerName': value['customerName'],
        'action': value['action'],
        'resourceType': value['resourceType'],
        'resourceId': value['resourceId'],
        'sessionId': value['sessionId'],
        'userId': value['userId'],
        'username': value['username'],
        'timestamp': value['timestamp'],
        'businessContext': value['businessContext'],
    };
}

